export default "__VITE_ASSET__8cdYgt8T__"